module.exports = __webpack_public_path__ + "media/images/players/VARNER_III_HAROLD-c8133752a301135a6046a7c4601e4940.png";